( function( app ) {
  const SLIDER_THRESHOLD = 1;
  const SLIDER_DURATION = 3000 * SLIDER_THRESHOLD;
  const COMPONENT = {
    className: 'image-roll',
    instances: null,
    init: function() {
      this.initTabs();
      this.bindClick();
      this.observe();
    },
    initTabs: function() {
      this.getInstances()?.forEach( ( $instance ) => {
        const $tabs = $instance.querySelectorAll( '.group' ) || [];
        $tabs?.forEach( ( $tab ) => {
          this.initTab( $tab, $instance );
        } );

        $instance.__tab = new Proxy( {
          isActive: false,
          activeTabIndex: 0,
          $activeTab: null,
          progress: 0,
          timer: null,
          lastTime: null,
          startTime: null,
          animationLoopRef: null,
          tabs: $tabs,
          stop() {
            setTimeout( () => {
              cancelAnimationFrame( $instance.__tab.animationLoopRef );
            }, 0 );
          },
          start( time ) {
            if ( !$instance.__tab.lastTime ) {
              $instance.__tab.lastTime = time;
            }

            if ( !$instance.__tab.startTime ) {
              $instance.__tab.startTime = time;
            }

            $instance.__tab.timer = time - $instance.__tab.startTime;
            const delta = time - $instance.__tab.lastTime;
            $instance.__tab.progress += Math.min( delta / SLIDER_DURATION, 1 );
            $instance.__tab.lastTime = time;
            $instance.__tab.animationLoopRef = requestAnimationFrame( $instance.__tab.start );
          },
          setTab( index ) {
            if ( index === -1 ) return;

            $instance.__tab.reset();
            $instance.__tab.activeTabIndex = index;
            $instance.__tab.stop();
            $instance.__tab.progress = SLIDER_THRESHOLD;
          },
          nextTab() {
            if ( $instance.__tab.activeTabIndex + 1 <= $instance.__tab.tabs.length - 1 ) {
              $instance.__tab.activeTabIndex += 1;
            } else {
              $instance.__tab.activeTabIndex = 0;
            }

            $instance.__tab.reset();
          },
          reset() {
            $instance.__tab.progress = 0;
            $instance.__tab.startTime = null;
            $instance.__tab.lastTime = null;
            $instance.__tab.timer = null;
          },
          onClick( targetTab ) {
            targetTab?.classList.add( 'is-clicked' );
            const targetIndex = [...$instance.__tab.tabs]?.findIndex( ( tab ) => tab === targetTab );
            $instance.__tab.setTab( targetIndex );
          },
          onChange: {
            $activeTab( value, oldValue ) {
              setTimeout( () => {
                oldValue?.classList?.remove( 'is-active', 'is-clicked' );
                oldValue?.__tabImage?.deactivate();
                value?.classList?.add( 'is-active' );
                value?.__tabImage?.activate();
              }, 0 );
            },
            activeTabIndex( value ) {
              $instance.__tab.$activeTab = $instance.__tab.tabs[value];
            },
            isActive( value ) {
              if ( !$instance.__tab.$activeTab ) {
                $instance.__tab.$activeTab = $instance.__tab.tabs[$instance.__tab.activeTabIndex];
              }

              if ( $instance.__tab.progress >= SLIDER_THRESHOLD ) {
                setTimeout( () => {
                  $instance.__tab.$activeTab.classList.remove( 'is-clicked' );
                  $instance.__tab.reset();
                  $instance.__tab.stop();
                }, 0 );
              }

              if ( value ) {
                $instance.__tab.animationLoopRef = requestAnimationFrame( $instance.__tab.start );
              } else {
                $instance.__tab.stop();
              }
            },
            timer( value ) {
              if ( value >= SLIDER_DURATION && $instance.__tab.progress > SLIDER_THRESHOLD ) {
                setTimeout( () => {
                  $instance.__tab.nextTab();
                }, 0 );
              }
            },
            progress( value ) {
              $instance.__tab.$activeTab.style.setProperty( '--image-roll-progress', value );
            },
          },
        }, {
          set( tab, prop, value ) {
            const oldValue = tab[prop];
            tab[prop] = value;
            if ( typeof tab.onChange[prop] === 'function' && value !== oldValue ) {
              tab.onChange[prop]( value, oldValue );
            }

            return true;
          },
        } );
      } );
    },
    initTab: function( $tab, $tabGroup ) {
      $tab.__tabImage = $tabGroup.querySelectorAll( `[data-tab-image="${$tab.getAttribute( 'href' )}"]` );
      if ( $tab?.__tabImage ) {
        $tab.__tabImage.deactivate = function() {
          $tab.__tabImage.forEach( ( $img ) => {
            if ( $img.dataset.isMobile ) {
              $( $img ).slideUp();
            }

            $img.classList.remove( 'is-open' );
          } );
        };
        $tab.__tabImage.activate = function() {
          $tab.__tabImage.forEach( ( $img ) => {
            $img.classList.add( 'is-open' );
            if ( $img.dataset.isMobile ) {
              $( $img ).slideDown();
            }
          } );
        };
      }
    },
    observe: function() {
      const observer = new IntersectionObserver( ( entries ) => {
        entries.forEach( ( entry ) => {
          entry.target.__tab.isActive = entry.isIntersecting;
        } );
      }, {
        threshold: 0.5,
      } );

      this.getInstances()?.forEach( ( componentInstance ) => {
        observer.observe( componentInstance );
      } );
    },
    bindClick: function() {
      document.addEventListener( 'click', function( e ) {
        if ( !e.target.matches( '.js-image-roll-tab-trigger' ) ) return;
        e.preventDefault();

        const tabGroup = e.target.closest( '[data-component="image-roll"]' );
        tabGroup?.__tab.onClick( e.target );
        return false;
      } );
    },
    getInstances: function() {
      if ( this.instances ) {
        return this.instances;
      }

      return this.instances = document.querySelectorAll( '[data-component="image-roll"]' ) || [];
    },
    selector: function() {
      return '.' + this.className;
    },
    finalize: function() {
    },
  };

  app.registerComponent( 'image-roll', COMPONENT );
} )( app );
